<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Viewing Stock Details
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="bg-white p-1 rounded-[4px] mt-[16px]">
          <p class="text-[20px] font-bold text-[#2463EB] leading-[20px]">
            Issue Number: {{ issueStockDetails.issueNumber }}
          </p>
        </div>
        <div class="bg-white p-1 rounded-[4px] mt-[16px]">
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Issued To
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              {{ issueStockDetails.issueToName }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Issued By:
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              {{ issueStockDetails.issuedByName }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Value of Stock
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              &#8358; {{ formatMoney(issueStockDetails.totalValue) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Entry Date
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              {{ formatDate(issueStockDetails.entryDate) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Status
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              {{ StockIssuedStatus }}</span
            >
          </div>
        </div>
        <div class="bg-white p-1 rounded-[4px] mt-[16px]">
          <div class="">
            <h4 class="text-[#353535] text-[20px] leading-[20px] font-semibold">
              Issue Details
            </h4>
          </div>
          <div class="table-responsive mt-[16px]">
            <table class="table text-nowrap">
              <thead class="bg-[#ECF9FF]">
                <tr>
                  <th>Description</th>
                  <th>Price Per Quantity</th>
                  <th>Issued Quantity</th>
                  <th>Value</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Stock Left</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in issueStockDetails.details"
                  :key="index"
                >
                  <td>{{ item.description }}</td>
                  <td>&#8358; {{ formatMoney(item.price) }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>&#8358; {{ formatMoney(item.quantity * item.price) }}</td>
                  <td>{{ item.location }}</td>
                  <td>
                    <span v-if="item.status == 0" class="text-warning"
                      >Pending</span
                    >
                    <span class="text-success" v-else-if="item.status == 1"
                      >Completed</span
                    >
                    <span class="text-danger" v-else>Reversed</span>
                  </td>
                  <td>{{ item.stockLeft }}</td>
                  <td class="relative">
                    <button
                      v-if="issueStockDetails.issueToRole == 'Staff'"
                      :disabled="item.status == 1"
                      class="btn-no-border"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span
                        class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                      >
                        ...
                      </span>
                    </button>
                    <div
                      class="dropdown-menu shadow-none absolute bg-white"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div v-if="hasPermission('Stock_Issue_Record_Sales')">
                        <li
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click.prevent="addSalesAction(item.id)"
                        >
                          Sales
                        </li>
                      </div>
                      <div v-if="hasPermission('Stock_Issue_Record_Returns')">
                        <li
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                          @click.prevent="
                            addReturnAction(item.id, item.productId)
                          "
                        >
                          Returns
                        </li>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="!issueStockDetails.details">
                  <td colspan="12">
                    <div class="text-center" style="padding-top: 50px">
                      <span
                        style="font-size: 4.615rem"
                        class="mdi mdi-tag-multiple"
                      ></span>
                    </div>
                    <h3 class="text-center" style="padding-bottom: 100px">
                      You don't have any issued stock.
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="bg-white p-1 rounded-[4px] mt-[16px]">
          <div class="" id="printing">
            <h4 class="text-[#353535] text-[20px] leading-[20px] font-semibold">
              Stock Report
            </h4>
          </div>
          <div class="table-responsive mt-[16px]" id="printing">
            <table class="table text-nowrap">
              <thead class="bg-[#ECF9FF]">
                <tr>
                  <th>Description</th>
                  <th>Price Per Quantity</th>
                  <th>Quantity</th>
                  <th>Action</th>
                  <th>Customer</th>
                  <th>Order Number</th>
                  <th>Location</th>
                  <th>Entry Date</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in issueStockDetails.reports"
                  :key="index"
                >
                  <td>{{ item.description }}</td>
                  <td>&#8358; {{ formatMoney(item.price) }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.action }}</td>
                  <td>{{ item.customer == null ? "N/A" : item.customer }}</td>
                  <td>
                    {{ item.orderNumber == null ? "N/A" : item.orderNumber }}
                  </td>
                  <td>{{ item.location == null ? "N/A" : item.location }}</td>
                  <td>{{ formatDate(item.entryDate) }}</td>
                </tr>
                <tr
                  v-if="
                    !issueStockDetails ||
                      !issueStockDetails.reports ||
                      !issueStockDetails.reports.length
                  "
                >
                  <td colspan="12">
                    <div class="text-center" style="padding-top: 50px">
                      <span
                        style="font-size: 4.615rem"
                        class="mdi mdi-tag-multiple"
                      ></span>
                    </div>
                    <h3 class="text-center" style="padding-bottom: 100px">
                      You don't have any issued stock.
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- return and sales modal -->
    <div
      class="modal fade py-1"
      id="modal-add-Returns-Sales-FormToggle"
      role="dialog"
    >
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <div>
              <h4
                class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
              >
                {{
                  !addReturnsSalesFormToggle
                    ? " Add Sales Actions"
                    : "Add Return Action"
                }}
              </h4>
            </div>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <!-- SALES ACTION -->
            <section v-if="!addReturnsSalesFormToggle">
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Select Customer</label
                >
                <div>
                  <select
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    v-model="issueStockDetailsFileds.customerID"
                  >
                    <option
                      v-for="cO in userOptions"
                      :key="cO.id"
                      :value="cO.id"
                    >
                      {{ cO.value }}
                    </option>
                  </select>
                  <ul v-if="v1.customerID" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Quantity Sold</label
                >
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    type="text"
                    placeholder="Enter quantity"
                    v-model.number="issueStockDetailsFileds.qtySold"
                  />
                  <ul v-if="v1.qtySold" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[10px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Sales Date</label
                >
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    :class="[{ 'is-invalid': v1.salesdate }]"
                    type="date"
                    :max="maxDate"
                    placeholder="Select a date"
                    v-model="issueStockDetailsFileds.salesdate"
                  />
                  <ul v-if="v1.salesdate" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[16px]">
                <div>
                  <label
                    class="custom-control custom-checkbox custom-control-inline mb-0"
                  >
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      v-model="issueStockDetailsFileds.recordPayment"
                    />
                    <span class="custom-control-label">Record Payment</span>
                  </label>
                  <ul
                    v-if="v1.recordPayment"
                    class="parsley-errors-list filled"
                  >
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div v-if="issueStockDetailsFileds.recordPayment">
                <div class="pb-[16px]">
                  <label
                    class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                    >Select Payment Channnel</label
                  >
                  <div>
                    <select
                      class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                      v-model="issueStockDetailsFileds.paymentChannel"
                    >
                      <option
                        v-for="ch in paymentChannelList"
                        :key="ch.id"
                        :value="ch.id"
                      >
                        {{ prepareDetail(ch) }}
                      </option>
                    </select>
                    <ul
                      v-if="v1.paymentChannel"
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                  </div>
                </div>
                <div class="pb-[16px]">
                  <label
                    class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                    >Amount</label
                  >
                  <div>
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                      type="text"
                      placeholder="Enter quantity"
                      v-model.number="issueStockDetailsFileds.amount"
                    />
                    <ul v-if="v1.amount" class="parsley-errors-list filled">
                      <li class="parsley-required">Required.</li>
                    </ul>
                  </div>
                </div>
                <div class="pb-[16px]">
                  <label
                    class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                    >Select Payment Date</label
                  >
                  <div>
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                      :class="[, { 'is-invalid': v1.paymentDate }]"
                      type="date"
                      :max="maxDate"
                      placeholder="Select a date"
                      v-model="issueStockDetailsFileds.paymentDate"
                    />
                    <ul
                      v-if="v1.paymentDate"
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <!-- RETURNS ACTION -->
            <section v-else>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Select Warehouse</label
                >
                <div>
                  <select
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    v-model="issueStockDetailsFileds.wareHouse"
                    @change="getSpecificSubLocation($event.target.value)"
                  >
                    <option
                      v-for="warehouse in warehouseList"
                      :key="warehouse.id"
                      :value="warehouse.id"
                    >
                      {{ warehouse.value == null ? "N/A" : warehouse.value }}
                    </option>
                  </select>
                  <ul v-if="v1.wareHouse" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Select Storage</label
                >
                <div>
                  <select
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    v-model="issueStockDetailsFileds.storageArea"
                    @change="getInventory($event.target)"
                  >
                    <option
                      v-for="storageArea in storageAreaList"
                      :key="storageArea.id"
                      :value="storageArea.id"
                    >
                      {{ storageArea.name == null ? "N/A" : storageArea.name }}
                    </option>
                  </select>
                  <ul v-if="v1.storageArea" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Return Date</label
                >
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    :class="[{ 'is-invalid': v1.returnDate }]"
                    type="date"
                    :max="maxDate"
                    placeholder="Select a date"
                    v-model="issueStockDetailsFileds.returnDate"
                  />
                  <ul v-if="v1.returnDate" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Quantity to return</label
                >
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                    type="text"
                    placeholder="Enter quantity to return"
                    v-model.number="issueStockDetailsFileds.returnQty"
                  />
                  <ul v-if="v1.returnQty" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click.prevent="clearFormFields"
            >
              Cancel
            </button>
            <button
              v-if="!addReturnsSalesFormToggle"
              :disabled="!isSalesFormValid || isBusy"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="recordSales"
            >
              <span v-if="isBusy">Busy...</span>
              <span v-else>Add</span>
            </button>
            <button
              v-else
              :disabled="!isReturnsFormValid || isBusy"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="recordReturns"
            >
              <span v-if="isBusy">Busy...</span>
              <span v-else>Proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import moment from "moment";
import GeneralDeleteCaution from "../GeneralDeleteCaution.vue";
import Pagination from "../Pagination.vue";
export default {
  props: ["closeModal", "stockID"],
  mixins: [SystemPermissions.Mixin],
  name: "IssueStockDetails",
  components: {
    Select2,
    GeneralDeleteCaution,
    Pagination,
  },

  data() {
    return {
      modalName: "",
      isBusy: false,
      issueStockDetails: [],
      userOptions: [],
      warehouseList: [],
      storageAreaList: [],
      inventoryList: [],
      subLocation: [],
      paymentChannelList: [],
      addReturnsSalesFormToggle: false,
      stockIssueDetailId: "",
      action: "",
      iemID: "",
      issueStockDetailsFileds: {
        customerID: "",
        qtySold: "",
        salesdate: "",
        recordPayment: false,
        inventoryID: "",
        wareHouse: "",
        storageArea: "",
        returnDate: "",
        returnQty: "",
        amount: 0,
        paymentDate: "",
        paymentChannel: "",
      },
      v1: {
        customerID: false,
        qtySold: false,
        salesdate: false,
        recordPayment: false,
        inventoryID: false,
        wareHouse: false,
        storageArea: false,
        returnDate: false,
        returnQty: false,
        amount: false,
        paymentDate: false,
        paymentChannel: false,
      },
      StockIssuedStatus: "",
      StockIssuedDetailStatus: "",
      StockIssuedReportStatus: "",
      maxDate: "",
      detailsProductId: "",
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    isSalesFormValid() {
      const fields = this.issueStockDetailsFileds;
      return (
        fields.customerID &&
        fields.qtySold &&
        fields.salesdate &&
        (!fields.recordPayment ||
          (fields.paymentChannel && fields.amount && fields.paymentDate))
      );
    },
    isReturnsFormValid() {
      const fields = this.issueStockDetailsFileds;
      return (
        fields.wareHouse &&
        fields.storageArea &&
        fields.returnDate &&
        fields.returnQty
      );
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
    this.getIssueStock();
    this.getUserData();
    this.getLocations();
    this.getSubLocations();
    this.getPaymentChannel();
  },

  methods: {
    cancelConfirmModal() {
      $("#mod-confirm-payment").modal("hide");
      this.modalName = "";
    },

    getSpecificSubLocation(val) {
      this.storageAreaList = this.subLocation.filter(
        (x) => x.location.id == val
      );
    },

    clearFormFields() {
      this.issueStockDetailsFileds.customerID = "";
      this.issueStockDetailsFileds.qtySold = "";
      this.issueStockDetailsFileds.salesdate = "";
      this.issueStockDetailsFileds.recordPayment = false;
      this.issueStockDetailsFileds.inventoryID = "";
      this.issueStockDetailsFileds.wareHouse = "";
      this.issueStockDetailsFileds.storageArea = "";
      this.issueStockDetailsFileds.returnDate = "";
      this.issueStockDetailsFileds.returnQty = "";
      this.issueStockDetailsFileds.amount = 0;
      this.issueStockDetailsFileds.paymentDate = "";
      this.issueStockDetailsFileds.paymentChannel = "";
    },
    prepareDetail(value) {
      const name = value.paymentChannelTypeName;
      let result = "";
      if (name) {
        result += name;

        if (name.toLowerCase() === "bank") {
          result += "/ " + value.bankName + "/ " + value.accountNumber;
        } else if (name.toLowerCase() === "pos") {
          result += "/ " + value.bankName + "/ " + value.terminalId;
        } else if (name.toLowerCase() === "cryptocurrency") {
          result += "/ " + value.bankName + "/ " + value.walletAddress;
        }
      }
      return result;
    },

    getIssueStock() {
      this.isBusy = true;
      var id = this.stockID;
      this.$http
        .get(`/StockIssues/${id}`)
        .then(function(res) {
          this.issueStockDetails = res.body;
          if (this.issueStockDetails.status == 0) {
            this.StockIssuedStatus = "Issued";
          } else if (this.issueStockDetails.status == 1) {
            this.StockIssuedStatus = "Reversed";
          } else {
            this.StockIssuedStatus = "Deleted";
          }
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    addSalesAction(id) {
      this.stockIssueDetailId = id;
      this.addReturnsSalesFormToggle = false;
      $("#modal-add-Returns-Sales-FormToggle").modal("show");
    },
    addReturnAction(id, productID) {
      this.detailsProductId = productID;
      this.stockIssueDetailId = id;
      this.addReturnsSalesFormToggle = true;
      $("#modal-add-Returns-Sales-FormToggle").modal("show");
    },

    deleteReverseModal(id, action) {
      this.action = action;
      $("#mod-action-res").modal("show");
      this.itemID = id;
    },
    closeDeleteReverseModal() {
      $("#mod-action-res").modal("hide");
      this.itemID = "";
      this.action = "";
    },

    async recordSales() {
      this.isBusy = true;
      var id = this.stockID;
      let data = {
        customerId: this.issueStockDetailsFileds.customerID,
        stockIssueDetailId: this.stockIssueDetailId,
        quantitySold: this.issueStockDetailsFileds.qtySold,
        dateSold: this.issueStockDetailsFileds.salesdate,
      };
      await this.$http
        .post(`/StockIssues/${id}/RecordSale`, data)
        .then(function(res) {
          if (res.ok) {
            if (this.issueStockDetailsFileds.recordPayment) {
              this.recordPayment(res.body);
            } else {
              this.isBusy = false;
              this.getIssueStock();
              $("#modal-add-Returns-Sales-FormToggle").modal("hide");
              this.clearFormFields();
            }
          }
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    async recordPayment(val) {
      var id = this.stockID;
      let data = {
        orderId: val,
        paymentDate: this.issueStockDetailsFileds.paymentDate,
        amountPaid: this.issueStockDetailsFileds.amount,
        paymentChannelId: this.issueStockDetailsFileds.paymentChannel,
      };
      await this.$http
        .post(`/StockIssues/${id}/RecordPayment`, data)
        .then(function(res) {
          if (res.ok) {
            this.issueStockDetailsFileds.recordPayment = false;
            $("#modal-add-Returns-Sales-FormToggle").modal("hide");
            this.isBusy = false;
            this.getIssueStock();
            this.clearFormFields();
          }
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    async recordReturns() {
      this.isBusy = true;
      var id = this.stockID;
      let data = {
        stockIssueDetailId: this.stockIssueDetailId,
        subLocationId: this.issueStockDetailsFileds.storageArea,
        returnDate: this.issueStockDetailsFileds.returnDate,
        quantityReturned: this.issueStockDetailsFileds.returnQty,
      };
      await this.$http
        .post(`/StockIssues/${id}/RecordReturn`, data)
        .then(function(res) {
          if (res.ok) {
            this.isBusy = false;
            this.getIssueStock();
            this.$toast.success(res.body, {
              icon: false,
              rtl: false,
            });
            $("#modal-add-Returns-Sales-FormToggle").modal("hide");
            this.clearFormFields();
          }
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    async getUserData() {
      this.isBusy = true;
      try {
        const res = await this.$http.get(`/Users/listNoPagging?isCustomer`);
        if (res.ok) {
          this.userOptions = res.body
            .filter((user) => user.name)
            .map((user) => ({
              id: user.id,
              value: user.name,
            }));
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isBusy = false;
        $("#mod-filter").modal("hide");
      }
    },
    async getPaymentChannel() {
      try {
        const response = await this.$http.get(
          "/PaymentChannels/getListNoPaging?active=true" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        );

        if (response.ok) this.paymentChannelList = response.body;
      } catch (error) {}
    },
    getInventory(val) {
      if (!val) return;

      this.isBusy = true;
      this.$http
        .get(
          `/Inventories/getProductInventories?ProductId=${this.detailsProductId}&subLocationId=${val}`
        )
        .then((res) => {
          this.inventoryList = res.body.map((inventory) => ({
            id: inventory.inventoryId,
            value: inventory.inventoryName,
          }));
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    getLocations() {
      const a = true;
      this.$http
        .get(
          `/Locations/getListNoPaging?active=${a}&parentId=${this.user.parentId}`
        )
        .then((res) => {
          this.warehouseList = res.body.map((location) => ({
            id: location.id,
            value: location.name || "N/A",
          }));
        })
        .catch(() => {});
    },
    getSubLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/SubLocations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&locationId="
        )
        .then(function(res) {
          this.subLocation = res.body;
        })
        .catch(function() {});
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatDate(date) {
      return moment(date).format("ll");
    },
  },
};
</script>
